<body class="sidebar-noneoverflow">
<div class="header-container fixed-top">
  <header class="header navbar navbar-expand-sm">
    <mat-toolbar style="background: #2A499A;">
      <span class="theme-text" style="color: white; font-size: 20px;">Federata e Futbollit e Kosovës</span>
      <span class="spacer"></span>
      <mat-toolbar style="background: #2A499A;">
        <button (click)="sidenavToggle()" mat-icon-button style="color: white" type="button">
          <mat-icon>menu</mat-icon>
        </button>
        <span></span>
      </mat-toolbar>
      <div class="user-menu" style="margin-right: 1rem">
        <button [matMenuTriggerFor]="userMenuLanguage" mat-button style="color: white">
          <mat-icon>language</mat-icon>
          <span>{{ currentLang }}</span>
        </button>
        <mat-menu #userMenuLanguage="matMenu">
          <div class="user-profile-section">
            <div class="media mx-auto">
              <div class="media-body">
              </div>
            </div>
          </div>
          <button (click)="changeLanguage('sq')" mat-menu-item>
            <span>{{ 'Albanian' | translate }}</span>
          </button>
          <button (click)="changeLanguage('en')" mat-menu-item>
            <span>{{ 'English' | translate }}</span>
          </button>
        </mat-menu>
      </div>
      <div class="user-menu">
        <button [matMenuTriggerFor]="userMenu" mat-button style="color: white">
          <span class="username">{{!isEmptyObject(currentUser) ? currentUser?.email : '' }}</span>
          <mat-icon>person</mat-icon>
        </button>
        <mat-menu #userMenu="matMenu">
          <div class="user-profile-section">
            <div class="media mx-auto">
              <div class="media-body">
              </div>
            </div>
          </div>
          <button (click)="logout()" mat-menu-item>
            <mat-icon>logout</mat-icon>
            <span>{{ 'Log Out' | translate }}</span>
          </button>
        </mat-menu>
      </div>
    </mat-toolbar>
  </header>
</div>

<div class="main-container" id="container">
  <div class="sidebar-wrapper sidebar-theme">
    <mat-sidenav-container class="m-sidenav-container">
      <mat-sidenav #sidenav [ngClass]="{'m-sidenav': true, 'm-sidenav-small': sidenavSmall}" fixedInViewport="true"
                   mode="side" opened>
        <div class="m-sidenav__handle">
          <mat-nav-list>
            <a [routerLink]="['/editor-panel/editor-news']" mat-list-item>
              <i class="fa-solid fa-newspaper icon-spacing"></i>
              <span>{{'News' | translate}}</span>
            </a>
            <a [routerLink]="['/editor-panel/editor-profile']" mat-list-item>
              <i class="fa-solid fa-user icon-spacing"></i>
              <span>{{'Profile' | translate}}</span>
            </a>
          </mat-nav-list>
        </div>
      </mat-sidenav>
      <mat-sidenav-content [ngClass]="{'m-main': true, 'm-main-large': sidenavSmall}">
        <div class="content-wrapper">
          <div class="layout-px-spacing">
            <router-outlet></router-outlet>
          </div>
        </div>
      </mat-sidenav-content>
    </mat-sidenav-container>
  </div>
</div>
</body>
